/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Os_CompatInputs */

const en_field_os_compat = /** @type {(inputs: Field_Os_CompatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatibility`)
};

const es_field_os_compat = /** @type {(inputs: Field_Os_CompatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatibilidad`)
};

const fr_field_os_compat = /** @type {(inputs: Field_Os_CompatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatibilité`)
};

const de_field_os_compat = /** @type {(inputs: Field_Os_CompatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompatibilität`)
};

const ja_field_os_compat = /** @type {(inputs: Field_Os_CompatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対応OS`)
};

const zh_field_os_compat = /** @type {(inputs: Field_Os_CompatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`兼容性`)
};

const ar_field_os_compat = /** @type {(inputs: Field_Os_CompatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التوافق`)
};

const id_field_os_compat = /** @type {(inputs: Field_Os_CompatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompatibilitas`)
};

const it_field_os_compat = /** @type {(inputs: Field_Os_CompatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatibilità OS`)
};

const ru_field_os_compat = /** @type {(inputs: Field_Os_CompatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Совместимость с ОС`)
};

const pt_field_os_compat = /** @type {(inputs: Field_Os_CompatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatibilidade`)
};

const ko_field_os_compat = /** @type {(inputs: Field_Os_CompatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`호환성(OS)`)
};

/**
* | output |
* | --- |
* | "Compatibility" |
*
* @param {Field_Os_CompatInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_os_compat = /** @type {((inputs?: Field_Os_CompatInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Os_CompatInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_os_compat(inputs)
	if (locale === "es") return es_field_os_compat(inputs)
	if (locale === "fr") return fr_field_os_compat(inputs)
	if (locale === "de") return de_field_os_compat(inputs)
	if (locale === "ja") return ja_field_os_compat(inputs)
	if (locale === "zh") return zh_field_os_compat(inputs)
	if (locale === "ar") return ar_field_os_compat(inputs)
	if (locale === "id") return id_field_os_compat(inputs)
	if (locale === "it") return it_field_os_compat(inputs)
	if (locale === "ru") return ru_field_os_compat(inputs)
	if (locale === "pt") return pt_field_os_compat(inputs)
	return ko_field_os_compat(inputs)
});